import type { ColppyPriceListDto, ColppyPriceListItemDto, ColppyProductDto, DepositoDisponibilidadDto, ItemAndAvailabilityDto, ProximoNumeroRemitoResponseDto, RemitoItemDto } from './dto/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { CreateOrderItemDto, StockValidationResultDto } from '../orders/models';

@Injectable({
  providedIn: 'root',
})
export class ColppyService {
  apiName = 'Default';
  

  cancelRemito = (idRemito: string, orderItems: CreateOrderItemDto[], shippingAddressLine: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/colppy/cancel-remito',
      params: { idRemito, shippingAddressLine },
      body: orderItems,
    },
    { apiName: this.apiName,...config });
  

  createRemito = (fechaContable: string, nroRemito1: string, nroRemito2: string, depositoSalida: string, nombreCliente: string, itemsRemito: RemitoItemDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'POST',
      responseType: 'text',
      url: '/api/app/colppy/remito',
      params: { fechaContable, nroRemito1, nroRemito2, depositoSalida, nombreCliente },
      body: itemsRemito,
    },
    { apiName: this.apiName,...config });
  

  createRemitoByOrderManagementByOrderItemsAndShippingAddressLine = (OrderItems: CreateOrderItemDto[], ShippingAddressLine: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'POST',
      responseType: 'text',
      url: '/api/app/colppy/remito-by-order-management',
      params: { shippingAddressLine: ShippingAddressLine },
      body: OrderItems,
    },
    { apiName: this.apiName,...config });
  

  getDisponibilidadPorDeposito = (idItem: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DepositoDisponibilidadDto[]>({
      method: 'GET',
      url: '/api/app/colppy/disponibilidad-por-deposito',
      params: { idItem },
    },
    { apiName: this.apiName,...config });
  

  getIdItemFromCacheOrApi = (externalCode: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'GET',
      responseType: 'text',
      url: '/api/app/colppy/id-item-from-cache-or-api',
      params: { externalCode },
    },
    { apiName: this.apiName,...config });
  

  getIdItemPorCodigo = (codigoItem: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'GET',
      responseType: 'text',
      url: '/api/app/colppy/id-item-por-codigo',
      params: { codigoItem },
    },
    { apiName: this.apiName,...config });
  

  getPriceListItems = (priceListId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ColppyPriceListItemDto[]>({
      method: 'GET',
      url: `/api/app/colppy/price-list-items/${priceListId}`,
    },
    { apiName: this.apiName,...config });
  

  getPriceLists = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ColppyPriceListDto[]>({
      method: 'GET',
      url: '/api/app/colppy/price-lists',
    },
    { apiName: this.apiName,...config });
  

  getProximoNumeroRemito = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProximoNumeroRemitoResponseDto>({
      method: 'GET',
      url: '/api/app/colppy/proximo-numero-remito',
    },
    { apiName: this.apiName,...config });
  

  getStockPorCodigoYDeposito = (codigoItem: string, nombreDeposito: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/app/colppy/stock-por-codigo-yDeposito',
      params: { codigoItem, nombreDeposito },
    },
    { apiName: this.apiName,...config });
  

  getStockProductos = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ColppyProductDto[]>({
      method: 'GET',
      url: '/api/app/colppy/stock-productos',
    },
    { apiName: this.apiName,...config });
  

  getWineAvailabilityFromCache = (cacheKey: string = "WineAvailabilityCache", config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<string, ItemAndAvailabilityDto[]>>({
      method: 'GET',
      url: '/api/app/colppy/wine-availability-from-cache',
      params: { cacheKey },
    },
    { apiName: this.apiName,...config });
  

  iniciarSesion = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'POST',
      responseType: 'text',
      url: '/api/app/colppy/iniciar-sesion',
    },
    { apiName: this.apiName,...config });
  

  refreshWineAvailabilityCache = (cacheKey: string = "WineAvailabilityCache", expiration?: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/colppy/refresh-wine-availability-cache',
      params: { cacheKey, expiration },
    },
    { apiName: this.apiName,...config });
  

  remitoExists = (idRemito: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/colppy/remito-exists',
      params: { idRemito },
    },
    { apiName: this.apiName,...config });
  

  validateStock = (orderItems: CreateOrderItemDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, StockValidationResultDto[]>({
      method: 'POST',
      url: '/api/app/colppy/validate-stock',
      body: orderItems,
    },
    { apiName: this.apiName,...config });
  

  validateStockByDeposit = (orderItems: CreateOrderItemDto[], depositName: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StockValidationResultDto[]>({
      method: 'POST',
      url: '/api/app/colppy/validate-stock-by-deposit',
      params: { depositName },
      body: orderItems,
    },
    { apiName: this.apiName,...config });
  

  validateStockByMultipleDeposits = (orderItems: CreateOrderItemDto[], depositNames: string[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, StockValidationResultDto[]>({
      method: 'POST',
      url: '/api/app/colppy/validate-stock-by-multiple-deposits',
      body: depositNames,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
